import baseReport from "../baseReportImpressao";
import Meses from "@/utils/dias";
import formatDataBR from "@/plugins/filters/formatDataBR";



const montarTableHeader = (data, isUltimo = false, indicaanoletivoexcedeu = 'N') => {
  let mesAnterior = "";
  const totalGeral = [];
  const auxTotalGeral = [{}];

  if (isUltimo) {
    totalGeral.push({
      text: "Total\nGeral",
      alignment: "center",
      margin: [0, 7, 0, 0],
      rowSpan: 2,
      style: "tableHeader"
    });
  } else {
    auxTotalGeral.shift();
  }

  return [
    [
      {
        text: "Alunos",
        alignment: "center",
        margin: [0, 7, 0, 0],
        rowSpan: 2,
        style: "tableHeader"
      },
      ...data.map(key => {
        if (key.mes !== mesAnterior) {
          mesAnterior = key.mes;
          return {
            text: indicaanoletivoexcedeu === 'S' ? `${Meses.mesesMin[key.mes - 1]}\n${key.ano}` : Meses.mesesMin[key.mes - 1],
            alignment: "center",
            colSpan: data.filter(n => n.mes === key.mes).length,
            bold: true,
            style: "tableHeader2"
          };
        }
        return {};
      }),
      {
        text: "Faltas",
        alignment: "center",
        margin: [-4, 7, -4, 0],
        rowSpan: 2,
        fontSize: 6,
        style: "tableHeader"
      },
      ...totalGeral
    ],
    [
      "",
      ...data.map(key => ({
        text: key.dia,
        alignment: "center",
        fontSize: 6,
        margin: [-4, 0, -4, 0],
        style: "tableHeader"
      })),
      {},
      ...auxTotalGeral
    ]
  ];
};



const montarAssinatura = (professores, filtros, tipoDeEnsino) => {
  return [
    {
      columns: [
        { width: "*", text: "" },
        {
          width: "auto",
          alignment: "right",
          layout: "noBorders",
          table: {
            body: [
                ...professores.map(key => ([{
                  alignment: "center",
                  fontSize: 8,
                  margin: [15, 35, 15, 0],
                  text: [
                    "_____________________________________________\n",
                    "Assinatura do Professor/Educador\n",
                    `${key.nmfuncion}\n`,
                    `${key.cdpessoal}-${key.cdmatric}`
                  ]
                }]))
            ]
          }
        },
        { width: "*", text: "" }
      ]
    },
    {
      fontSize: 9,
      italics: true,
      margin: [0, 20, 0, 0],
      text: [
        { text: "Obs.: ", bold: true },
        filtros.aaletivo >= 2020 && tipoDeEnsino === "I"
          ? "Este relatório apresenta todas as aulas cadastradas correspondentes a campos de experiência."
          : "Este relatório apresenta todas as aulas cadastradas correspondentes a disciplina."
      ]
    }
  ];
};

const registroFrequenciaAnalitico = async ({
  date,
  time,
  filtros,
  data,
  periodos,
  periodo,
  professores,
  tipoDeEnsino,
  indicaanoletivoexcedeu = 'N'
}) => {
  const headerFooter = await baseReport(
    { date, time, title: "Diário de Classe", subTitle: "Registro de Frequência Analítico" },
    "landscape"
  );

  let nameProfessores = professores.reduce((total, key) => `${total}${key.nmfuncion.trim()}, `, "");
  nameProfessores = nameProfessores.substring(0, nameProfessores.length - 2);

  const filtrosFormated = [
    {
      text: filtros.nmescola,
      bold: true,
      fontSize: 12,
      alignment: "center",
      margin: [0, 5, 0, 5]
    },
    {
      fontSize: 9,
      text: [{ text: "Professor/Educador:   ", bold: true }, nameProfessores]
    },
    {
      fontSize: 9,
      columns: [
        {
          text: [{ text: "Ano letivo:   ", bold: true }, filtros.aaletivo]
        },
        {
          alignment: "right",
          text: [{ text: "Turma:   ", bold: true }, filtros.turma]
        }
      ]
    },
    {
      fontSize: 9,
      columns: [
        {
          text: [
            {
              text:
                filtros.aaletivo >= 2020 && tipoDeEnsino === "I"
                  ? "Campos de Experiência:   "
                  : "Disciplina:   ",
              bold: true
            },
            filtros.disciplina
          ]
        },
        {
          alignment: "right",
          text: [{ text: "Período:   ", bold: true }, filtros.periodo]
        }
      ]
    }
  ];

  if (data.length <= 0 || (data.length > 0 && data[0].faltas.length <= 0)) {
    return {
      ...headerFooter,
      content: [
        {
          text: "Nenhuma frequência encontrada.",
          fontSize: 10,
          alignment: "center",
          margin: [0, 15, 0, 0],
          bold: true
        }
      ]
    };
  }


  let periodosFiltered = periodos;
  periodosFiltered.shift();
  if (periodo !== "-1") {
    periodosFiltered = periodosFiltered.filter(key => key.value === periodo);
  }

  let controle = 0;


  const dataFormated = periodosFiltered.map((key, index) => {
    const isFim = periodosFiltered.length - 1 === index;
    const frequencia = [];
    const frequenciaSm = [];
    let faltasPeriodo = [];
    let faltasPeriodoSm = [];


    for (const aluno of data) {
      const faltas = [];
      const faltasSm = [];
      let total = 0;




      if (aluno.faltas[0].cdpravadi === "13") {
        faltasPeriodo = aluno.faltas.filter(f => f.mes <= 5 && f.cdpravadi === "13");
        faltasPeriodoSm = aluno.faltas.filter(f => f.mes > 5 && f.cdpravadi === "13");
      }

      if (periodo === "14") {
        faltasPeriodo = aluno.faltas.filter(f => f.mes <= 10 && f.cdpravadi === "14");
        faltasPeriodoSm = aluno.faltas.filter(f => f.mes > 10 && f.cdpravadi === "14");
      }

      if (controle === 1) {
        if (aluno.faltas.some(f => f.cdpravadi === "14")) {
          faltasPeriodo = aluno.faltas.filter(f => f.mes <= 10 && f.cdpravadi === "14");
          faltasPeriodoSm = aluno.faltas.filter(f => f.mes > 10 && f.cdpravadi === "14");
        }
      }

      if (aluno.faltas[0].cdpravadi >= 19 && aluno.faltas[0].cdpravadi <= 21) {
        faltasPeriodo = aluno.faltas.filter(f => f.cdpravadi === key.value);
        //console.log('FaltasPeriodo: ',faltasPeriodo.length, '  FaltaPeriodos2: ', faltasPeriodoSm.length);
      }

      // eslint-disable-next-line no-restricted-syntax
      for (const n of faltasPeriodo) {
        faltas.push({ text: n.qnt > 0 ? n.qnt : "-", alignment: "center" });
        // eslint-disable-next-line radix
        total += parseInt(n.qnt);
      }

      for (const n of faltasPeriodoSm) {
        faltasSm.push({ text: n.qnt > 0 ? n.qnt : "-", alignment: "center" });
        // eslint-disable-next-line radix
        total += parseInt(n.qnt);
      }


      const linha = [
        `${aluno.nmaluno}\nDt Enturmação: ${formatDataBR(aluno.dtsitalun)}${
          aluno.situacao_fim ? ` - ${aluno.situacao_fim.dssitalun}` : ""
        }` + `${aluno.dtafastam ? ` - ${formatDataBR(aluno.dtafastam)}` : ""}`,

        ...faltas,
        { text: total, alignment: "center" }
      ];
      // console.log( getDay(new Date(aluno.dtsitalun))+'/'+getMonth(new Date(aluno.dtsitalun))+'/'+getYear(new Date(aluno.dtsitalun)) );
      //console.log(formatDataBR(aluno.dtsitalun))
      const linhaSm = [
        // aluno.nmaluno,
        `${aluno.nmaluno}\nDt Enturmação: ${formatDataBR(aluno.dtsitalun)}${
          aluno.situacao_fim ? ` - ${aluno.situacao_fim.dssitalun}` : ""
        }` + `${aluno.dtafastam ? ` - ${formatDataBR(aluno.dtafastam)}` : ""}`,
        ...faltasSm,
        { text: total, alignment: "center" }
      ];


      if (isFim && periodo === "-1") {
        linha.push({ text: aluno.totalGeral, alignment: "center" });
      }

      if (isFim && periodo === "-1") {
        linhaSm.push({ text: aluno.totalGeral, alignment: "center" });
      }

      frequencia.push(linha);
      frequenciaSm.push(linhaSm);

    }

    // debugger;
    // console.log('frequencia', frequencia);
    // console.log('frequenciaSm', frequenciaSm);


    controle = controle + 1;

    const totalGeral = [{ width: "auto", alignment: "center" }];
    if (!(isFim && periodo === "-1")) {
      totalGeral.shift();
    }

    if (frequencia.length <= 0) {
      return {};
    }
    if (frequenciaSm.length <= 0) {
      return {};
    } //Adicionado



    let periodoAvalitivoTexto = {
      text: `Período Avaliativo: ${key.text}`,
      alignment: "center",
      bold: true,
      margin: [0, 10, 0, 0],
      fontSize: 10
    };


    let objFaltaPeriodo = {
      margin: [0, 10, 0, 0],
      fontSize: 7,
      table: {
        style: "display:none",
        widths: [
          { width: "*" },
          ...faltasPeriodo.map(() => ({ width: "0.13%" })),
          { width: "auto", fontSize: 6 },
          ...totalGeral
        ],
        headerRows: 2,
        dontBreakRows: true,

        body: [...montarTableHeader(faltasPeriodo, isFim && periodo === "-1",indicaanoletivoexcedeu), ...frequencia]
      },
      pageBreak: isFim ? "" : "after",
      pageBreak: "after"
    };

    let objFaltaPeriodoSm = {
      margin: [0, 10, 0, 0],
      fontSize: 7,
      table: {
        style: "display:none",
        widths: [
          { width: "*" },
          ...faltasPeriodoSm.map(() => ({ width: "0.13%" })),
          { width: "auto", fontSize: 6 },
          ...totalGeral
        ],
        headerRows: 2,
        dontBreakRows: true,

        body: [...montarTableHeader(faltasPeriodoSm, isFim && periodo === "-1", indicaanoletivoexcedeu), ...frequenciaSm]
      },
      pageBreak: isFim ? "" : "after"
    };


    // console.log('objFaltaPeriodo', objFaltaPeriodo);
    // console.log('objFaltaPeriodoSm', objFaltaPeriodoSm);

    if (faltasPeriodoSm.length === 0) {
      return [
        {
          ...periodoAvalitivoTexto
        },
        {
          ...objFaltaPeriodo
        }
      ];
    } else {
      return [
        {
          ...periodoAvalitivoTexto
        },
        {
          ...objFaltaPeriodo
        },
        {
          ...objFaltaPeriodoSm
        }
      ];
    }



  });




  //console.log('DataFormated', dataFormated);


  return {
    ...headerFooter,
    content: [
      ...filtrosFormated,
      ...dataFormated,
      ...montarAssinatura(professores, filtros, tipoDeEnsino)
    ],
    styles: {
      tableHeader: {
        bold: true,
        fontSize: 10,
        color: "black",
        fillColor: "#eeeeee"
      },
      tableHeader2: {
        bold: true,
        fontSize: 8,
        color: "black",
        fillColor: "#eeeeee"
      }
    }
  };
};

export default registroFrequenciaAnalitico;
